import type { SelectedSegmentWithMode } from '../components/SelectedContextualSegmentItem.tsx';
import type { GroupedSegmentItem } from '../components/SelectedSegmentsWithSections.tsx';

export const createGroupedSegmentItems = (
  selectedIncludes: SelectedSegmentWithMode[],
  selectedExcludes: SelectedSegmentWithMode[]
): GroupedSegmentItem[] => {
  const items: GroupedSegmentItem[] = [];

  items.push({ type: 'section-header', sectionType: 'includes', id: 'section-includes' });

  if (selectedIncludes.length > 0) {
    items.push(...selectedIncludes.map(item => ({ ...item, type: 'segment' as const })));
  } else {
    items.push({ type: 'empty-state', sectionType: 'includes', id: 'empty-includes' });
  }

  items.push({ type: 'section-header', sectionType: 'excludes', id: 'section-excludes' });

  if (selectedExcludes.length > 0) {
    items.push(...selectedExcludes.map(item => ({ ...item, type: 'segment' as const })));
  } else {
    items.push({ type: 'empty-state', sectionType: 'excludes', id: 'empty-excludes' });
  }

  return items;
};
